<template>
  <div class="floating-controls">
    <!-- Customer Service -->
    <div class="control-item customer-service" :class="{ 'expanded': activeControl === 'customer' }"
         @mouseenter="activeControl = 'customer'" @mouseleave="activeControl = null">
      <div class="control-icon service-icon">
        <i class="fas fa-headset"></i>
        <span>在线客服</span>
      </div>
      <div class="control-content service-content">
        <div class="service-item">
          <h3><i class="fas fa-phone"></i> 联系电话</h3>
          <p class="phone-number">17771499181</p>
          <p class="service-time">周一 至 周日 9:00 ~ 22:00</p>
        </div>
        <div class="service-item">
          <h3><i class="fas fa-qrcode"></i> 企业扫码咨询</h3>
          <div class="qr-code">
            <img src="@/assets/wechat_qrcode.png" alt="企业咨询二维码">
            <img src="@/assets/qq_qrcode.png" alt="企业咨询二维码">
          </div>
        </div>
      </div>
    </div>

    <!-- Expert Assistant -->
    <div class="control-item expert-assistant" :class="{ 'expanded': activeControl === 'expert' }"
         @mouseenter="activeControl = 'expert'" @mouseleave="activeControl = null">
      <div class="control-icon assistant-icon">
        <i class="fas fa-user-tie"></i>
        <span>专家助理</span>
      </div>
      <div class="control-content assistant-content">
        <div class="assistant-header">
          <h3><i class="fas fa-user-tie"></i> 人工专家助理</h3>
          <p class="desc">为您提供专业的一对一服务(付费)</p>
        </div>
        <div class="service-list">
          <div class="service-item">
            <i class="fas fa-palette"></i>
            <span>人工改图</span>
          </div>
          <div class="service-item">
            <i class="fas fa-cube"></i>
            <span>人工出3D模型</span>
          </div>
          <div class="service-item">
            <i class="fas fa-tag"></i>
            <span>AI服务</span>
          </div>
          <div class="service-item">
            <i class="fas fa-comments-dollar"></i>
            <span>付费咨询</span>
          </div>
        </div>
        <div class="contact-info">
          <p class="contact-title">联系方式</p>
          <!-- <p class="phone-number">17771499181</p> -->
          <div class="qr-code">
            <img src="@/assets/tech_qrcode.png" alt="专家助理二维码">
            <p>使用QQ扫码添加专家助理</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingControls',
  data() {
    return {
      activeControl: null
    }
  }
}
</script>

<style scoped>
.floating-controls {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.control-item {
  position: relative;
  display: flex;
  justify-content: flex-end; /* Align content to the right */
}

.control-icon {
  width: 42px;
  color: white;
  padding: 10px 8px;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  box-sizing: border-box;
}

.control-icon:hover {
  transform: translateX(-5px);
}

.control-icon i {
  font-size: 20px;
}

.control-icon span {
  font-size: 12px;
  writing-mode: vertical-lr;
  margin-top: 3px;
  letter-spacing: 2px;
}

.service-icon {
  background: #1890ff;
}

.assistant-icon {
  background: #ff7043;
}

.control-content {
  position: absolute;
  right: 42px; /* Position to the left of the icon */
  top: 0;
  background: white;
  padding: 20px;
  width: 300px;
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 2px 12px rgba(0, 0, 0, 0.1);
  opacity: 0;
  visibility: hidden;
  transform: translateX(20px);
  transition: all 0.3s ease;
  pointer-events: none; /* Prevent interaction when hidden */
}

.control-item.expanded .control-content {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  pointer-events: auto;
}

/* Service Content Styles */
.service-item {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.service-item:last-child {
  border-bottom: none;
}

.service-item h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.service-time {
  color: #666;
  font-size: 14px;
  margin: 5px 0;
}

.phone-number {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}

.service-content .phone-number {
  color: #1890ff;
}

.qr-code {
  text-align: center;
  padding: 10px 0;
}

.qr-code img {
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
}

/* Assistant Content Styles */
.assistant-content {
  width: 320px;
}

.assistant-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.assistant-header h3 {
  font-size: 18px;
  color: #333;
  margin: 0 0 5px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.assistant-header h3 i {
  color: #ff7043;
}

.desc {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.service-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 20px;
}

.service-list .service-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff5f2;
  padding: 8px;
  border-radius: 4px;
  color: #d84315;
  font-size: 13px;
  border-bottom: none; /* Override default service-item style */
}

.contact-info {
  text-align: center;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
}

.contact-title {
  font-size: 14px;
  color: #666;
  margin: 0 0 5px 0;
}

.contact-info .phone-number {
  color: #ff7043;
  margin: 0 0 15px 0;
}

.contact-info .qr-code img {
  width: 140px;
  height: 140px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.contact-info .qr-code p {
  color: #999;
  font-size: 12px;
  margin: 0;
}

@media (max-width: 768px) {
  .floating-controls {
    display: none;
  }
}
</style>
